import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { AppConfig } from '../../core/services/app-config.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { Offers } from '../models/offers';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  constructor(
    private apiService: ApiService,
    private authStoreService: AuthStoreService,
    private appConfig: AppConfig,
  ) {}

  public loadOffers(): Observable<Offers> {
    return this.apiService.get<Offers>('/offers', null, true);
  }
  public save(selectedIds: string[]): Observable<any> {
    return this.apiService.put(
      `/customers/${this.authStoreService.userInfo.customer_id}/offer-subcategories`,
      selectedIds,
    );
  }
}
